import React from 'react';
import Navbar from './components/Navbar';
import Background from './components/Background';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';

import { profile, projects, experience, skills } from './data/content';

function App() {
  return (
    <>
      <Background />
      <div className="content">
        <Navbar />
        <Hero name={profile.name} role={profile.role} summary={profile.summary} socials={profile.socials} />
        <About />
        <Projects projects={projects} />
        <Experience items={experience} />
        <Skills skills={skills} />
        <Contact email={profile.socials.email?.replace('mailto:', '') || 'you@example.com'} />
        <Footer />
      </div>
    </>
  );
}

export default App;
